import * as yup from 'yup';

export const TerminalFormSchema = yup.object().shape({
  shopId: yup.number().typeError('').required(),
});
